export default __webpack_public_path__ + "static/999-1cc25399b1ad85587b8e3d33891c8d0b.gif";